import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import IntroStrip from "@/components/landing/IntroStrip";
import WhyIqmize from "@/components/landing/WhyIqmize";
import LearningLoop from "@/components/landing/LearningLoop";
import CoreSkills from "@/components/landing/CoreSkills";
import SevenDayProgram from "@/components/landing/SevenDayProgram";
import StudentsParents from "@/components/landing/StudentsParents";
import Techniques from "@/components/landing/Techniques";
import ExamPrep from "@/components/landing/ExamPrep";
import BookSection from "@/components/landing/BookSection";
import Coaching from "@/components/landing/Coaching";
import ClosingSections from "@/components/landing/ClosingSections";
import ContactSection from "@/components/landing/ContactSection";
import Footer from "@/components/landing/Footer";
import FloatingWhatsApp from "@/components/landing/FloatingWhatsApp";
import PaymentModal from "@/components/landing/PaymentModal";
import Stats from "@/pages/Stats";
import Privacy from "@/pages/Privacy";

const LandingPage = () => (
  <div className="min-h-screen bg-background" data-testid="landing-page">
    <Nav />
    <main>
      <Hero />
      <IntroStrip />
      <WhyIqmize />
      <LearningLoop />
      <CoreSkills />
      <SevenDayProgram />
      <StudentsParents />
      <Techniques />
      <ExamPrep />
      <BookSection />
      <Coaching />
      <ClosingSections />
      <ContactSection />
    </main>
    <Footer />
    <FloatingWhatsApp />
    <PaymentModal />
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/stats" element={<Stats />} />
          <Route path="/privacy" element={<Privacy />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
